import React from 'react';
import 'twin.macro';

import Heading from '~components/Heading';

interface TitleBarProps {
  icon: React.ReactElement;
}

const TitleBar: React.FC<TitleBarProps> = ({ icon, children }) => (
  <div tw="py-6 bg-gray-900">
    <div tw="container">
      <div tw="flex items-center justify-between space-x-6">
        <Heading level="h2" tw="text-gray-50 text-5xl">
          {children}
        </Heading>
        {icon}
      </div>
    </div>
  </div>
);

export default TitleBar;
